<template>
    <v-btn
        v-if="car"
        elevation="0"
        :to="!isOrder ? route || null : null"
        @click.stop="isOrder ? $emit('selectCar', car.id) : onPress()"
        class="car-item-btn"
        :class="{'car-item-wrapper-order': isOrder}"
    >
        <div class="car-item-container">
            <div v-if="isOrder" class="mr-4 form-radio">
                <input type="radio" :id="car.id" :value="car.id" name="carToSelect" v-model="selectedCar" />
                <label :for="car.id"></label>
            </div>
            <div class="car-item">
                <div class="date" v-if="!isOrder">
                    Последнее ТО: {{ date }}
                </div>
                <div class="model">
                    {{ model }}, {{yearManufacture}}
                </div>
                <div class="params">
                    <div class="numberPlate">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 8.66667V15.3333C21 15.7754 20.8259 16.1993 20.5161 16.5118C20.2062 16.8244 19.786 17 19.3478 17H3.65217C3.21399 17 2.79375 16.8244 2.48391 16.5118C2.17407 16.1993 2 15.7754 2 15.3333V8.66667C2 8.22464 2.17407 7.80072 2.48391 7.48816C2.79375 7.1756 3.21399 7 3.65217 7H19.3478C19.786 7 20.2062 7.1756 20.5161 7.48816C20.8259 7.80072 21 8.22464 21 8.66667ZM18.3478 15.3333C18.9001 15.3333 19.3478 14.8856 19.3478 14.3333V9.66667C19.3478 9.11438 18.9001 8.66667 18.3478 8.66667H4.65217C4.09989 8.66667 3.65217 9.11438 3.65217 9.66667V14.3333C3.65217 14.8856 4.09989 15.3333 4.65217 15.3333H18.3478Z" fill="#3fab3e"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13 12C13 11.4477 12.4883 11 11.8571 11H6.14286C5.51167 11 5 11.4477 5 12C5 12.5523 5.51167 13 6.14286 13H11.8571C12.4883 13 13 12.5523 13 12Z" fill="#3fab3e"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14 12C14 11.4477 14.597 11 15.3333 11H16.6667C17.403 11 18 11.4477 18 12C18 12.5523 17.403 13 16.6667 13H15.3333C14.597 13 14 12.5523 14 12Z" fill="#3fab3e"/>
                        </svg>
                        {{ numberPlate }}
                    </div>
                    <div class="mileage">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_819_2314)">
                            <path d="M12 0C5.38322 0 0 5.38322 0 12C0 18.6168 5.38322 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38322 18.6168 0 12 0ZM20.0408 19.192L18.364 17.5152L17.5156 18.3636L19.1924 20.0404C17.2816 21.7512 14.7664 22.8 12 22.8C9.23358 22.8 6.71841 21.7512 4.80759 20.0408L6.48441 18.364L5.63602 17.5156L3.9592 19.192C2.37398 17.4212 1.36959 15.1288 1.23042 12.6H3.6V11.4H1.23042C1.36964 8.87119 2.37441 6.57881 3.95963 4.80759L5.63644 6.48441L6.48483 5.63602L4.80802 3.9592C6.57881 2.37398 8.87123 1.36959 11.4 1.23042V3.6H12.6V1.23042C15.1288 1.36964 17.4212 2.37441 19.1924 3.95963L17.5156 5.63644L18.364 6.48483L20.0408 4.80802C21.626 6.57881 22.6304 8.87123 22.77 11.4004H20.4V12.6004H22.7696C22.6304 15.1288 21.626 17.4212 20.0408 19.192Z" fill="#3fab3e"/>
                            <path d="M12.5992 12.7103V7.19995H11.3992V12.7103C10.7024 12.9587 10.1992 13.6187 10.1992 14.4C10.1992 15.3923 11.0068 16.2 11.9992 16.2C12.9916 16.2 13.7992 15.3923 13.7992 14.4C13.7992 13.6187 13.296 12.9592 12.5992 12.7103ZM11.9992 15C11.668 15 11.3992 14.7312 11.3992 14.4C11.3992 14.0687 11.668 13.8 11.9992 13.8C12.3304 13.8 12.5992 14.0687 12.5992 14.4C12.5992 14.7312 12.3304 15 11.9992 15Z" fill="#3fab3e"/>
                            <path d="M15 19.2H9V20.4H15V19.2Z" fill="#3fab3e"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_819_2314">
                            <rect width="24" height="24" fill="white"/>
                            </clipPath>
                            </defs>
                        </svg>
                        ~{{ mileage }} км
                    </div>
                </div>
            </div>
        </div>
    </v-btn>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'

    export default {
        name: 'CarItem',

        props: {
            car: { type: Object },
            route: { type: Object },
            click: { type: Function },
            selectedCar: String,
        },

        computed: {
            ...mapGetters({
                getCarHistoryByCarId: 'carHistory/getCarHistoryByCarId',
            }),

            carHistory() {
                return this.getCarHistoryByCarId(this.car?.id) || []
            },

            model() {
                return this.car?.model
            },

            yearManufacture() {
                return this.car?.yearManufacture || ''
            },

            numberPlate() {
                return this.car?.numberPlate
            },

            mileage() {
                return this.carHistory[0]?.mileage || this.car?.mileage || 0
            },

            date() {
                const unix = this.carHistory[0]?.date

                if (unix) {
                    return moment.unix(unix).utcOffset(5).locale('ru').format('LL')
                } else {
                    return null
                }
            },

            isOrder() {
                return this.$route.path.includes('online-order')
            },
        },

        watch: {
            // selectedCar: {
            //     handler() {
            //     },
            // },
        },

        methods: {
            onPress() {
                if (!this.route) {
                    this.$emit('click', this.car?.id)
                }
            },
        },
    }
</script>

<style scoped>
    .car-item {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
    }
    .car-item .params {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
    }
    .mobile .car-item .params div{
        font-size: 14px;
        padding: 8px 14px;
    }
    .car-item .params div{
        display: flex;
        padding: 8px 14px;
        justify-content: flex-start;
        align-items: center;
        gap: 5px;
        border-radius: 24px;
        border: 1px solid #F3F4F4;
        background: #F3F4F4;
    }
    .mileage {
        min-width: 124px;
        margin-left: 8px;
        font-size: 14px;
    }
    .numberPlate {
        min-width: 126px;
        font-size: 14px;
    }
    .mobile .mileage {
        min-width: 50%;
        width: 100%;
        margin-left: 8px;
    }
    .mobile .is-order .mileage {
        margin-left: 0px;
    }
    .mobile .numberPlate {
        min-width: 40%;
        width: 100%;
    }
    .model {
        color: #36393B;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
    }
    .mobile .model {
        overflow: hidden;
        color: #36393B;
        text-overflow: ellipsis;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
    }
    .date {
        color: #4D5056;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%;
    }
    .mobile .date {
        color: #4D5056;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%;
    }
    .car-item-container {
        display: flex;
    }

    .form-radio input[type=radio] {
        display: none;
    }
    .form-radio label {
        display: inline-block;
        cursor: pointer;
        position: relative;
        padding-left: 25px;
        margin-right: 0;
        line-height: 24px;
        user-select: none;
    }
    .form-radio label:before {
        content: "";
        display: inline-block;
        width: 24px;
        height: 24px;
        position: absolute;
        left: 0;
        bottom: -12px;
        background: url('~@/assets/radioUnchecked.svg') 0 0 no-repeat;
    }

    .form-radio input[type=radio]:checked + label:before {
        background: url('~@/assets/radioChecked.svg') 0 0 no-repeat;
    }
    .form-radio label:hover:before {
        background: url('~@/assets/radioHover.svg') 0 0 no-repeat;
    }
    .car-item-wrapper-order:hover .form-radio label:before {
        background: url('~@/assets/radioHover.svg') 0 0 no-repeat;
    }
    .mobile .car-item-wrapper-order .params {
        flex-wrap: wrap;
        gap: 8px;
    }
    /* .car-item-btn {
        display: flex;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        border: 1.5px solid #DA251C;
        width: 165px;
        height: 52px;
        background: #fff !important;
        color: #DA251C;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    } */
    .car-item-btn::before {
        background: #fff !important;
    }
    .car-item-btn:hover {
        background: #fff !important;
        border: 1.5px solid #DA251C;
    }
</style>
